var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-title-box",class:_vm.centered?'':'ta_l'},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('div',{staticClass:"content-title-border",class:_vm.centered?'':'left_17'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }